export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';

export default (state = {}, action) =>
  action.type === FETCH_DATA_SUCCESS ? { ...state, [action.payload.pathname]: action.payload.data } : state;
